import React from 'react';
import { motion } from 'framer-motion';
import { experiences } from '../../data/experiences';
export function ExperienceTimeline() {
  return <div className="space-y-5" data-id="element-149" data-mp="2mxlk6dtumaot">
      {experiences.map((role, index) => <motion.div key={role.title + role.period} initial={{
      opacity: 0,
      y: 14
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-10% 0px'
    }} transition={{
      duration: 0.4,
      delay: index * 0.05,
      ease: [0.23, 1, 0.32, 1]
    }} className="grid grid-cols-1 gap-6 rounded-xl border border-slate-200 bg-white p-8 transition-colors duration-200 hover:border-brandgreen/50 lg:grid-cols-4 lg:gap-10" data-id="element-150" data-mp="31tt2f8lp521g" data-mpi={index}>
          <div className="lg:col-span-1" data-id="element-151" data-mp="2e59r0k7co955">
            <p className="font-heading text-base font-semibold leading-snug text-navy" data-id="element-152" data-mp="2e48dm92v3ak9">{role.title}</p>
            <p className="mt-1.5 text-sm font-medium text-brandgreen" data-id="element-153" data-mp="1qdumqlw0jhr9">{role.org}</p>
            <p className="mt-2 text-xs font-medium uppercase tracking-wide text-slate-500" data-id="element-154" data-mp="1lgcktfgey2sr">{role.period}</p>
          </div>
          <div className="lg:col-span-3" data-id="element-155" data-mp="318oqka5k0j16">
            <ul className="space-y-2.5" data-id="element-156" data-mp="35bb9tmo5svmr">
              {role.highlights.map(item => <li key={item} className="flex gap-2.5 text-sm leading-relaxed text-charcoal" data-id="element-157" data-mp="3a2b92ykr3psf">
                  <span className="mt-2 h-1 w-1 shrink-0 rounded-full bg-brandgreen" aria-hidden="true" data-id="element-158" data-mp="3f2fqcqthgojp" />
                  {item}
                </li>)}
            </ul>
          </div>
        </motion.div>)}
    </div>;
}